import React from 'react'
import ProgressCard from './../../../Initiatives/Drive/cards/ProgressCard';
import { dispatch } from '@rematch/core';
import { Grid,Message } from 'semantic-ui-react'
import LoadingComponent from './../../../../common/LoadingComponent';

class UserAssignedInitiativeActivity extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }
    componentWillMount() {
        this.clearFilter();
    }

    clearFilter() {
        this.props.advancedFilterProperties.roles = [];
        this.props.advancedFilterProperties.stateActiveChecked = false;
        this.props.advancedFilterProperties.stateOnHoldChecked = false;
        this.props.advancedFilterProperties.statusNotStartedChecked = false;
        this.props.advancedFilterProperties.statusCompletedChecked = false;
        this.props.advancedFilterProperties.statusIssueChecked = false;
        this.props.advancedFilterProperties.statusInProgressChecked = false;
        this.props.advancedFilterProperties.statusDelayedChecked = false;
        this.props.advancedFilterProperties.showAllRoles = false;
        this.props.advancedFilterProperties.serarchedRolesAvailable = false;
        this.props.advancedFilterProperties.searchedRoles = [];
        this.props.advancedFilterProperties.value = '';
        this.props.advancedFilterProperties.userSearchValue = '';
        this.props.advancedFilterProperties.selectedUsers = [];
        this.props.advancedFilterProperties.serarchedUsersAvailable = false;
        dispatch.initiatives.setAdvancedFilterProperties(Object.assign({}, this.props.advancedFilterProperties));
    
        this.props.raciFilterProperties.raciAllChecked = true;
        this.props.raciFilterProperties.accountable = false;
        this.props.raciFilterProperties.responsible = false;
        this.props.raciFilterProperties.consulted = false;
        this.props.raciFilterProperties.informed = false;
        dispatch.initiatives.setRACIFilterProperties(Object.assign({}, this.props.raciFilterProperties));
      }
      
      componentWillUnmount() {
        this.endFun()
      }
      async endFun() {
        await dispatch.organizationUnit.showResourecePane(null)
        await dispatch.initiatives.showResourecePane(null);
        await dispatch.initiatives.setSelectedActivityData({});
      }

    render() {
        let noInitiativeMessage = false;
		if (this.props.match.params.initiativeId === this.props.selectedDataById._id && this.props.selectedDataById && this.props.selectedDataById.status === 3) {
			noInitiativeMessage = true;

		} else {
			noInitiativeMessage = false;
        }
        
        return (
            <div>
                <Grid className="initiative_overall_progress w_100" >
                    <Grid.Row className="pad_0">

                    {noInitiativeMessage ?
							<span className="w_100" style={{ 'margin-bottom': '0px', 'margin-top': '-10px' }}>
								{noInitiativeMessage ? <Message fluid content="This initiative has been closed" warning className="mar_10	" /> : null}
							</span> : ''
						}

                        {this.props.loadingMyActivities ?
                            <LoadingComponent active={this.props.loadingMyActivities}
                                message="Fetching Initiative Activities"
                            /> :
                            <ProgressCard activityNodes={this.props.initiativeMemberActivities.myActivities}
                                noInitiativeMessage={noInitiativeMessage}
                                {...this.props} />
                        }
                    </Grid.Row>
                </Grid>
            </div>


        )
    }
}

export default UserAssignedInitiativeActivity;
